// Formatadores puros compartilhados pela superfície de Relatório.
// Extraídos de RelatorioIndex.vue sem alteração de comportamento.

export function currentMonthKey() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
}

export function periodRange(key) {
  const [y, m] = key.split('-').map(Number);
  const inicio = new Date(y, m - 1, 1).toISOString().slice(0, 10);
  const fim = new Date(y, m, 0).toISOString().slice(0, 10);
  return { inicio, fim };
}

// Últimos 12 meses (mês corrente primeiro) usados no seletor de período.
export const monthlyPeriodOptions = () => {
  const list = [];
  const now = new Date();
  for (let i = 0; i < 12; i += 1) {
    const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
    const key = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
    const label = d.toLocaleDateString('pt-BR', {
      month: 'long',
      year: 'numeric',
    });
    list.push({
      value: key,
      label: label.charAt(0).toUpperCase() + label.slice(1),
    });
  }
  return list;
};

export const formatBRL = value => {
  if (value == null || value === '') return '—';
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return String(value);

  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    maximumFractionDigits: 0,
  }).format(numeric);
};

export const formatArea = value => {
  if (value == null) return null;
  const numeric = Number(value);
  if (!Number.isFinite(numeric) || numeric <= 0) return null;

  return `${new Intl.NumberFormat('pt-BR', {
    maximumFractionDigits: 1,
  }).format(numeric)}m²`;
};

export const pluralizeFeature = (value, singular, plural, emptyLabel) => {
  const numeric = Number(value || 0);
  if (!numeric) return emptyLabel;

  return `${numeric} ${numeric === 1 ? singular : plural}`;
};

export const formatPercent = value => `${Number(value || 0)}%`;

export const formatCompactNumber = value =>
  new Intl.NumberFormat('pt-BR', {
    maximumFractionDigits: 1,
  }).format(Number(value || 0));

export const formatWaitingTime = seconds => {
  const totalSeconds = Number(seconds || 0);
  if (totalSeconds < 60) return 'menos de 1 min';
  const minutes = Math.floor(totalSeconds / 60);
  if (minutes < 60) return `${minutes} min`;
  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;
  return remainingMinutes ? `${hours}h ${remainingMinutes}min` : `${hours}h`;
};

// Converte a marcação [b]...[/b] das narrativas em segmentos renderizáveis.
export const markedTextSegments = text => {
  const parts = String(text || '').split(/(\[b\]|\[\/b\])/);
  let bold = false;

  return parts
    .filter(part => part !== '')
    .flatMap(part => {
      if (part === '[b]') {
        bold = true;
        return [];
      }
      if (part === '[/b]') {
        bold = false;
        return [];
      }
      return [{ text: part, bold }];
    });
};

export const parseCurrencyValue = value => {
  const normalized = String(value || '')
    .replace(/\./g, '')
    .replace(',', '.')
    .replace(/[^\d.]/g, '');
  const parsed = Number(normalized);

  return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
};

export const isIntegerCurrencyValue = value => {
  const raw = String(value || '').trim();
  if (!raw) return false;

  const normalized = raw
    .replace(/\s/g, '')
    .replace(/^R\$\s?/i, '')
    .replace(/\./g, '')
    .replace(',', '.');

  return /^\d+$/.test(normalized);
};

export const numericValue = value => {
  if (value == null || value === '') return null;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

export const propertyOptionLabel = imovel =>
  [
    imovel.titulo || imovel.title || `Imóvel ${imovel.id}`,
    imovel.code || imovel.codigo
      ? `Código ${imovel.code || imovel.codigo}`
      : '',
    [imovel.bairro, imovel.cidade].filter(Boolean).join(', '),
  ]
    .filter(Boolean)
    .join(' · ');
